import { IconDotsVertical as TablerIconDotsVertical } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconDotsVertical = /*#__PURE__*/ createOutlineIcon(
  TablerIconDotsVertical,
  'IconDotsVertical',
);
